import {chatHttpCall} from "./utils";

export const SonanNewMessageChecker = (function (baseUrl, chatToken) {

    function checkForMessages(){
        if (!chatToken){
            return;
        }

        chatHttpCall(baseUrl, chatToken, '/has-new', 'GET')
            .then(response => response.json())
            .then(json => {
                document.querySelectorAll('[data-chat-nm]').forEach(
                    element => element.setAttribute('data-chat-nm', json.newMessages) );
            });
    }

    return {
        checkForMessages: checkForMessages
    }
});
